<div
  class="sz-textarea"
  [class.sz-textarea--error]="errorText() !== null"
  [class.sz-textarea--disabled]="disabledState()">
  @if (label(); as labelText) {
    <label class="sz-textarea__label">{{ labelText }}</label>
  }
  <textarea
    class="sz-textarea__input"
    [placeholder]="placeholder()"
    [rows]="rows()"
    [value]="value()"
    [disabled]="disabledState()"
    [attr.maxlength]="maxLength()"
    (input)="onInput($event)"
    (blur)="onBlur()"></textarea>
  <div class="sz-textarea__meta">
    @if (errorText(); as err) {
      <span class="sz-textarea__error">{{ err }}</span>
    } @else if (helperText(); as helper) {
      <span class="sz-textarea__helper">{{ helper }}</span>
    }
    @if (showCounter() && maxLength() !== null) {
      <span class="sz-textarea__counter">{{ value().length }}/{{ maxLength() }}</span>
    }
  </div>
</div>
